export enum LinkType {
  StandardLink = 'standard_link',
  SingleLink = 'single_link_restricted',
  UnrestrictedLink = 'single_link_unrestricted',
}
